import { Configuration } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "80bd83f5-8d64-4e0e-a992-dc1bc9c5f404",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: "/",
  },
};
